import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { saveSecurityQuestions, verifySecurityQuestions } from '../bridge';
import '../styles/Auth.css';

const logo = require('../logo.jpeg');

const SecurityQuestions = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email || '';
  const mode = state?.mode || 'register'; // 'register' | 'recover'

  const [desiredName, setDesiredName] = useState('');
  const [favoriteDish, setFavoriteDish] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showSkipConfirm, setShowSkipConfirm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!desiredName.trim() || !favoriteDish.trim()) {
      setError('Please answer both questions.');
      return;
    }
    setLoading(true);

    if (mode === 'register') {
      const ok = await saveSecurityQuestions(email, desiredName.trim(), favoriteDish.trim());
      setLoading(false);
      if (!ok) {
        setError('Something went wrong. Please try again.');
        return;
      }
      navigate('/register/account-type', { state: { email } });
    } else {
      // mode === 'recover'
      const match = await verifySecurityQuestions(email, desiredName.trim(), favoriteDish.trim());
      setLoading(false);
      if (!match) {
        setError('The answers do not match our records. Please try again.');
        return;
      }
      navigate('/account-recovery/reset-password', { state: { email } });
    }
  };

  const handleSkip = () => {
    setShowSkipConfirm(true);
  };

  const confirmSkip = () => {
    navigate('/register/account-type', { state: { email } });
  };

  return (
    <div className="auth-page">
      <nav className="navbar">
        <div className="navbar-inner">
          <Link to="/" className="navbar-brand">
            <img src={logo} className="navbar-logo" alt="Menu & Catalog Maker" />
            <span className="navbar-title">Menu &amp; Catalog Maker</span>
          </Link>
        </div>
      </nav>

      <div className="auth-body">
        <div className="auth-card">
          <h1 className="auth-card-title">
            {mode === 'register' ? 'Security questions' : 'Verify your identity'}
          </h1>
          <p className="auth-card-subtitle">
            {mode === 'register'
              ? 'These answers help you recover your account if you forget your password.'
              : 'Answer your security questions to reset your password.'}
          </p>

          {error && <div className="auth-error">{error}</div>}

          {showSkipConfirm ? (
            <div>
              <p style={{ fontSize: 14, color: '#5C4A3B', marginBottom: 20, lineHeight: 1.6 }}>
                Without security questions you won't be able to recover your account if you forget your password. Are you sure you want to skip?
              </p>
              <button className="auth-submit" onClick={confirmSkip}>
                Yes, skip for now
              </button>
              <button className="auth-secondary" onClick={() => setShowSkipConfirm(false)}>
                Go back
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} noValidate>
              <div className="auth-field">
                <label className="auth-label">What is your desired name?</label>
                <input
                  className="auth-input"
                  type="text"
                  placeholder="Your answer"
                  value={desiredName}
                  onChange={e => setDesiredName(e.target.value)}
                />
              </div>
              <div className="auth-field">
                <label className="auth-label">What is your favorite dish?</label>
                <input
                  className="auth-input"
                  type="text"
                  placeholder="Your answer"
                  value={favoriteDish}
                  onChange={e => setFavoriteDish(e.target.value)}
                />
              </div>
              <button className="auth-submit" type="submit" disabled={loading}>
                {loading ? 'Verifying…' : mode === 'register' ? 'Continue' : 'Verify'}
              </button>
              {mode === 'register' && (
                <button type="button" className="auth-secondary" onClick={handleSkip}>
                  Skip
                </button>
              )}
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default SecurityQuestions;
